import config from 'config';

export const wrapperDialogDefaultProps = {
  dialogHeader: 'Confirmação',
  dialogBody: 'Informações não salvas serão perdidas. Deseja continuar?'
};

export const LinkContentPreview = (data) => `${config.api}/reports/ver/${data.slug}/${data.id}`;

export const LinkNewsletterPreview = (data) => `${config.api}/newsletters/ver/${data.id}`;

export const LinkAgendaPreview = (data) => `${config.api}/agendas/ver/${data.id}`;